import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

// Components
import { Alert, Col, Form, Icon, Input, Modal, Row, Select, Spin } from 'antd';

// Selectors
import { getAddOrEditSwitchModalIsLoading } from '../../../data/homes/selectors';
import { getRelayTypes, getRelayTypesIsLoading } from '../../../data/switch/selectors';

// Actions
import { onAddNewSwitch, onEditSwitch } from '../../../data/homes/actions';

// Constants
import {
    MODAL_SIZES,
    RELAY_TYPE_MODBUS,
    SWITCH_TYPE_EVCC,
    SWITCH_TYPE_MODBUS,
    SWITCH_TYPE_OCPP_GATEWAY, SWITCH_TYPE_SHELLY
} from '../../../constants/modal';
import {fetchAllSwitches, fetchRelayTypes} from '../../../data/switch/actions';

class AddOrEditSwitchModal extends PureComponent {

    componentDidMount() {
        const { fetchRelayTypes } = this.props;
        fetchRelayTypes([SWITCH_TYPE_EVCC, SWITCH_TYPE_MODBUS, SWITCH_TYPE_OCPP_GATEWAY, SWITCH_TYPE_SHELLY]);
        // TODO read that from backend com.wattanalytics.base.persistence.RelayModbusDatatype
        this.relayModbusDataTypes = [{label : 'UNSIGNED_INT'}, {label: 'SIGNED_INT'}, {label: 'FLOAT'}];
    }

    handleSubmit = () => {
        const { form, onAfterSubmit } = this.props;
        let formHasErrors = false;

        form.validateFields((err, values) => {
            if (err) {
                formHasErrors = true;
                return;
            }

            const { recordToEdit, msgs, params, onAddNewSwitch, onEditSwitch, meterId, splittSwitchAndRelay, fetchAllSwitches } = this.props;
            const switchObj = splittSwitchAndRelay(values, recordToEdit);

            if (switchObj.switchType === undefined) {
                if (switchObj.relays && switchObj.relays[0]) {
                    if (switchObj.relays[0].relayType === 'OcppGateway') {
                        switchObj.switchType = SWITCH_TYPE_OCPP_GATEWAY;
                    } else if (switchObj.relays[0].relayType === 'ModbusRegister') {
                        switchObj.switchType = SWITCH_TYPE_MODBUS;
                    } else if (switchObj.relays[0].relayType.startsWith('Shelly')) {
                        switchObj.switchType = SWITCH_TYPE_SHELLY;
                    } else {
                        switchObj.switchType = SWITCH_TYPE_EVCC;
                    }
                }
            }

            switchObj.relayCount = 1;
            switchObj.samplesPerMinute = 30;
            if (meterId !== null) {
                switchObj.meter = meterId;
            }
            if (switchObj.relays && switchObj.relays[0] && switchObj.relays[0].selector === undefined) {
                switchObj.relays[0].selector = 1;
            }
            if (!recordToEdit) {
                onAddNewSwitch(switchObj, params)
                    .then(() => {fetchAllSwitches(meterId);})
                    .catch(() => {
                    form.setFieldsValue({
                        hasError: msgs.homes.addHomeError
                    });
                });
            } else {
                onEditSwitch(switchObj, params)
                    .then(() => {fetchAllSwitches(meterId);})
                    .catch(() => {
                    form.setFieldsValue({
                        hasError: msgs.homes.editHomeError
                    });
                });
            }

        });

        if(!formHasErrors){
            onAfterSubmit();
        }
    };

    handleAlertClose = () => {
        const { form } = this.props;
        form.setFields({
            hasError: {
                value: undefined
            }
        });
    };

    showPhaseField = () => {
        const { recordToEdit } = this.props;
        const switchType = (recordToEdit && recordToEdit.switchType) || (recordToEdit && recordToEdit.switchObj && recordToEdit.switchObj.switchType);
        return !['Shelly'].includes(switchType);
    };

    render() {
        const relayModes = [{label:'ON'}, {label:'OFF'}, {label:'AUTO'}, {label:'ECOM'}, {label:'MAN'}]
        const relayPriorities = [{label:'A'}, {label:'B'}, {label:'C'}, {label:'D'}]

        const {
            form,
            isShown,
            isLoading,
            onCancel,
            recordToEdit,
            relayTypes,
            relayTypesIsLoading,
            msgs,
            deviceList
        } = this.props;
        const { getFieldValue, getFieldDecorator } = form;
        const relayTypeDisabled = recordToEdit && !recordToEdit.relayType && recordToEdit.switchType !== undefined;
        const showPhaseField = this.showPhaseField();

        return (
            <Modal
                key="admin-users-modal-add-or-edit"
                visible={isShown}
                confirmLoading={isLoading}
                width={MODAL_SIZES.MEDIUM}
                title={
                    !recordToEdit
                        ? msgs.homes.addSwitch
                        : `${msgs.homes.editSwitch} - ${
                            recordToEdit ? recordToEdit.brand : ''
                          }`
                }
                onCancel={onCancel}
                onOk={this.handleSubmit}
                cancelText={msgs.cancel}
                okText={msgs.save}
            >
                <Spin spinning={isLoading} size="large">
                    <Form>
                        {getFieldValue('hasError') && (
                            <Row>
                                <Col xs={24}>
                                    <Alert
                                        message={getFieldValue('hasError')}
                                        type="error"
                                        showIcon
                                        closable
                                        onClose={this.handleAlertClose}
                                    />
                                </Col>
                            </Row>
                        )}
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.switchModel}>
                                    {getFieldDecorator(relayTypeDisabled ? 'switchType': 'relayType', {
                                        initialValue: relayTypeDisabled ? recordToEdit.switchType : recordToEdit && recordToEdit.relayType,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(
                                        <Select
                                            type="text"
                                            dropdownMatchSelectWidth={false}
                                            placeholder={
                                                relayTypesIsLoading ? msgs.loading : msgs.select // placeholder is not working :(
                                            }
                                            notFoundContent={
                                                !relayTypesIsLoading ? (
                                                    <span>
                                                        <Icon type="loading" />
                                                        {` ${msgs.loading}`}
                                                    </span>
                                                ) : (
                                                    <span>{msgs.noData}</span>
                                                )
                                            }
                                            disabled={relayTypeDisabled}
                                        >
                                            {relayTypes && relayTypes.map(relayType => (
                                                <Select.Option value={relayType.label} key={relayType.label}>
                                                    {relayType.label}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.switchName}>
                                    {getFieldDecorator('brand', {
                                        initialValue: recordToEdit ? recordToEdit.brand : undefined,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(<Input type="text" maxLength={20}/>)}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.detail.meterIpAddress}>
                                    {getFieldDecorator('ip', {
                                        initialValue: recordToEdit ? recordToEdit.ip : undefined,
                                    })(<Input type="text" />)}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.relayMode}>
                                    {getFieldDecorator('mode', {
                                        initialValue: recordToEdit ? recordToEdit.mode : 'AUTO',
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(
                                        <Select
                                            type="text"
                                            dropdownMatchSelectWidth={false}
                                            placeholder={msgs.select}
                                        >
                                            {relayModes.map(mode => (
                                                <Select.Option value={mode.label} key={mode.label}>
                                                    {mode.label}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.relayDevice}>
                                    {getFieldDecorator('device', {
                                        initialValue: recordToEdit && recordToEdit.device,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(
                                        <Select
                                            type="text"
                                            dropdownMatchSelectWidth={false}
                                            placeholder={msgs.select}
                                        >
                                            {deviceList.map(device => (
                                                <Select.Option value={device.device} key={device.device}>
                                                    {device.name}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.relayPriority}>
                                    {getFieldDecorator('priority', {
                                        initialValue: recordToEdit ? recordToEdit.priority : 'A',
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(
                                        <Select
                                            type="text"
                                            dropdownMatchSelectWidth={false}
                                            placeholder={msgs.select}
                                        >
                                            {relayPriorities.map(mode => (
                                                <Select.Option value={mode.label} key={mode.label}>
                                                    {mode.label}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        {showPhaseField &&
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.relayPhase}>
                                        {getFieldDecorator('phase', {
                                            initialValue: recordToEdit ? recordToEdit.phase : 1
                                        })(
                                            <Select
                                                type="text"
                                                dropdownMatchSelectWidth={false}
                                                placeholder={msgs.select}
                                            >
                                                <Select.Option value={0} key='0'> {'Flex'} </Select.Option>
                                                <Select.Option value={1} key='1'> {'1'} </Select.Option>
                                                <Select.Option value={3} key='3'> {'3'} </Select.Option>
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }

                        {recordToEdit && recordToEdit.switchType !== SWITCH_TYPE_EVCC ? undefined : <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.modbusId}>
                                    {getFieldDecorator('selector', {
                                        initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.selector : 1
                                    })(
                                        (<Input type="number" min={1} />)
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        }

                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusStateFunctionCode}>
                                        {getFieldDecorator('modbusStateFunctionCode', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusStateFunctionCode : undefined,
                                        })(<Input type="text"/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusStateRegisterStartAddress}>
                                        {getFieldDecorator('modbusStateRegisterStartAddress', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusStateRegisterStartAddress : undefined,
                                        })(<Input type="text"/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusStateRegisterQuantity}>
                                        {getFieldDecorator('modbusStateRegisterQuantity', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusStateRegisterQuantity : undefined,
                                        })(<Input type="text"/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusStateMinValue}>
                                        {getFieldDecorator('modbusStateMinValue', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusStateMinValue : undefined,
                                        })(<Input type="text"/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusStateMaxValue}>
                                        {getFieldDecorator('modbusStateMaxValue', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusStateMaxValue : undefined,
                                        })(<Input type="text"/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusStateDataType}>
                                        {getFieldDecorator('modbusStateDataType', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusStateDataType : undefined,
                                        })(<Select
                                            type="text"
                                            dropdownMatchSelectWidth={false}
                                            placeholder={
                                                relayTypesIsLoading ? msgs.loading : msgs.select // placeholder is not working :(
                                            }
                                            disabled={relayTypeDisabled}
                                        >
                                            {this.relayModbusDataTypes && this.relayModbusDataTypes.map(modbusDataType => (
                                                <Select.Option value={modbusDataType.label} key={modbusDataType.label}>
                                                    {modbusDataType.label}
                                                </Select.Option>
                                            ))}
                                        </Select>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusStateFactor}>
                                        {getFieldDecorator('modbusStateFactor', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusStateFactor : undefined,
                                        })(<Input type="number" precision={4} step={0.1}/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }

                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusWattFunctionCode}>
                                        {getFieldDecorator('modbusWattFunctionCode', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusWattFunctionCode : undefined,
                                        })(<Input type="text"/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusWattRegisterStartAddress}>
                                        {getFieldDecorator('modbusWattRegisterStartAddress', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusWattRegisterStartAddress : undefined,
                                        })(<Input type="text"/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusWattRegisterQuantity}>
                                        {getFieldDecorator('modbusWattRegisterQuantity', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusWattRegisterQuantity : undefined,
                                        })(<Input type="text"/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusWattDataType}>
                                        {getFieldDecorator('modbusWattDataType', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusWattDataType : undefined,
                                        })(<Select
                                            type="text"
                                            dropdownMatchSelectWidth={false}
                                            placeholder={
                                                relayTypesIsLoading ? msgs.loading : msgs.select // placeholder is not working :(
                                            }
                                            disabled={relayTypeDisabled}
                                        >
                                            {this.relayModbusDataTypes && this.relayModbusDataTypes.map(modbusDataType => (
                                                <Select.Option value={modbusDataType.label} key={modbusDataType.label}>
                                                    {modbusDataType.label}
                                                </Select.Option>
                                            ))}
                                        </Select>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusWattFactor}>
                                        {getFieldDecorator('modbusWattFactor', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusWattFactor : undefined,
                                        })(<Input type="number" precision={4} step={0.1}/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }

                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusTempFunctionCode}>
                                        {getFieldDecorator('modbusTempFunctionCode', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusTempFunctionCode : undefined,
                                        })(<Input type="text"/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusTempRegisterStartAddress}>
                                        {getFieldDecorator('modbusTempRegisterStartAddress', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusTempRegisterStartAddress : undefined,
                                        })(<Input type="text"/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusTempRegisterQuantity}>
                                        {getFieldDecorator('modbusTempRegisterQuantity', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusTempRegisterQuantity : undefined,
                                        })(<Input type="text"/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusTempDataType}>
                                        {getFieldDecorator('modbusTempDataType', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusTempDataType : undefined,
                                        })(<Select
                                            type="text"
                                            dropdownMatchSelectWidth={false}
                                            placeholder={
                                                relayTypesIsLoading ? msgs.loading : msgs.select // placeholder is not working :(
                                            }
                                            disabled={relayTypeDisabled}
                                        >
                                            {this.relayModbusDataTypes && this.relayModbusDataTypes.map(modbusDataType => (
                                                <Select.Option value={modbusDataType.label} key={modbusDataType.label}>
                                                    {modbusDataType.label}
                                                </Select.Option>
                                            ))}
                                        </Select>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {(recordToEdit && recordToEdit.relayType !== RELAY_TYPE_MODBUS) || (getFieldValue('relayType') !== RELAY_TYPE_MODBUS) ? undefined :
                            <Row gutter={8}>
                                <Col xs={24}>
                                    <Form.Item label={msgs.homes.detail.modbusTempFactor}>
                                        {getFieldDecorator('modbusTempFactor', {
                                            initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.modbusTempFactor : undefined,
                                        })(<Input type="number" precision={4} step={0.1}/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        }
                        {(recordToEdit && recordToEdit.switchType === SWITCH_TYPE_EVCC && recordToEdit.relayObj &&
                        (recordToEdit.relayObj.label === 'ElliChargerConnect' || recordToEdit.relayObj.label === 'ElliChargerPro')) ? undefined :
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.homes.ski}>
                                    {getFieldDecorator('selector', {
                                        initialValue: recordToEdit && recordToEdit.relayObj ? recordToEdit.relayObj.selector : ''
                                    })(
                                        (<Input type="text" />)
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        }

                    </Form>
                </Spin>
            </Modal>
        );
    }

}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        isLoading: getAddOrEditSwitchModalIsLoading(state),
        relayTypes: getRelayTypes(state),
        relayTypesIsLoading: getRelayTypesIsLoading(state),
    }),
    {
        fetchRelayTypes,
        fetchAllSwitches,
        onAddNewSwitch,
        onEditSwitch
    }
)(Form.create()(AddOrEditSwitchModal));
